/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CsvProcedures/view.blocks to change it.
import Location from './Location/index'
import React from 'react'
import SetupAction from './SetupAction/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'



/** @type {import('Simple/types.js').View} */
export default function CsvProcedures({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Onboarding/CsvProcedures"
  
}) {
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Procedures"
/>
<Location
  viewPath={`${viewPath}/Location`}
/>
<SetupAction
  viewPath={`${viewPath}/SetupAction`}
/>
{children}
</React.Fragment>)
}